module.exports = __webpack_public_path__ + "img/mv.ee04bd81.png";